import get from 'lodash/get';
import { useDeprecatedFieldsContext } from '../contexts';
/** Returns whether a field that would otherwise be deprecated is available in the overrideDataSource object, which will show it anyways (ie signed note) */
export var useDeprecationIsOverridden = function (name, valueCheck) {
    if (valueCheck === void 0) { valueCheck = function (value) { return !!value; }; }
    var overrideDataSource = useDeprecatedFieldsContext().overrideDataSource;
    return valueCheck(get(overrideDataSource, name));
};
